import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";
import { STAGE_MAP } from "@/lib/constants";

const ACCEPTED = ["proposal_accepted", "live", "executed"];

export const StatusChangeDialog = ({ pending, onCancel, onConfirm }) => {
  const [reason, setReason] = useState("");
  const [lostType, setLostType] = useState("lost_proposal");
  useEffect(() => {
    if (pending) {
      setReason("");
      const wasAccepted = ACCEPTED.includes(pending.project.status) || (pending.project.status_history || []).some((h) => ACCEPTED.includes(h.to));
      setLostType(wasAccepted ? "cancelled_project" : "lost_proposal");
    }
  }, [pending]);
  if (!pending) return null;
  return (
    <Dialog open onOpenChange={(o) => !o && onCancel()}>
      <DialogContent className="max-w-md" data-testid="status-change-dialog">
        <DialogHeader>
          <DialogTitle>Mark as Lost / Cancelled</DialogTitle>
          <DialogDescription>
            Moving <span className="font-medium text-slate-800">{pending.project.project_code}</span> from {STAGE_MAP[pending.project.status]?.label}. History and financial records are kept.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <RadioGroup value={lostType} onValueChange={setLostType} className="grid grid-cols-2 gap-2">
            <Label className={`border rounded-md p-3 cursor-pointer text-sm ${lostType === "lost_proposal" ? "border-teal-500 bg-teal-50" : "border-slate-200"}`}>
              <RadioGroupItem value="lost_proposal" className="mr-2" data-testid="lost-type-proposal" />Lost proposal
              <span className="block text-xs text-slate-500 mt-1 ml-6">Client did not accept</span>
            </Label>
            <Label className={`border rounded-md p-3 cursor-pointer text-sm ${lostType === "cancelled_project" ? "border-teal-500 bg-teal-50" : "border-slate-200"}`}>
              <RadioGroupItem value="cancelled_project" className="mr-2" data-testid="lost-type-cancelled" />Cancelled project
              <span className="block text-xs text-slate-500 mt-1 ml-6">Accepted work was stopped</span>
            </Label>
          </RadioGroup>
          <div>
            <Label className="text-xs text-slate-600">Reason <span className="text-rose-500">*</span></Label>
            <Textarea data-testid="lost-reason-input" value={reason} onChange={(e) => setReason(e.target.value)} rows={3} className="mt-1.5" placeholder="e.g. Client chose a competitor on price" autoFocus />
          </div>
          <div className="flex justify-end gap-2">
            <Button variant="outline" onClick={onCancel} data-testid="lost-cancel-button">Keep current stage</Button>
            <Button data-testid="lost-confirm-button" className="bg-rose-600 hover:bg-rose-700" disabled={!reason.trim()} onClick={() => onConfirm({ reason: reason.trim(), lost_type: lostType })}>Confirm</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
